// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__pXEFJ","title":"About_title__+6bic","mission":"About_mission__tR0Vm"};